import { render } from "./ModalNewKpiChat.vue?vue&type=template&id=b4dcf366&scoped=true"
import script from "./ModalNewKpiChat.vue?vue&type=script&lang=js"
export * from "./ModalNewKpiChat.vue?vue&type=script&lang=js"

import "./ModalNewKpiChat.vue?vue&type=style&index=0&id=b4dcf366&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4dcf366"]])

export default __exports__